import PropTypes from 'prop-types'
import React from 'react'

import LinkInlineArrowShort from 'components/LinkInlineArrowShort'
import Modal from 'components/Modal'
import TooltipButton from 'components/TooltipButton'
import TooltipInfo from 'components/TooltipInfo'
import { MenuMainConsumer } from 'contexts/MenuMain'
import { TextSmallDescr } from 'styles/components/typography'

const DeliveryTooltip = ({ texts, path, tablet, mobile, leftIndentNode }) => {
  const modalRef = React.useRef(null)
  const textRef = React.useRef(null)
  const [modalOpened, setModalOpened] = React.useState(false)
  const tooltipInfo = React.useMemo(
    () => (
      <TooltipInfo
        data={texts.delivery.info}
        asideImage={{
          image: `${path}/tooltips_icons/box`,
          imageType: 'png',
          imageSizes: {
            xs: 223,
            md: 333,
          },
        }}
      />
    ),
    [texts.delivery.info, path],
  )

  return mobile ? (
    <>
      <LinkInlineArrowShort as="span" className="link--inverted text-left">
        <TextSmallDescr
          onClick={() => setModalOpened(true)}
          dangerouslySetInnerHTML={{
            __html: texts.delivery.content,
          }}
        />
      </LinkInlineArrowShort>
      <Modal
        modalRef={modalRef}
        modalOpen={modalOpened}
        handleCloseModal={() => setModalOpened(false)}
        isMobile={true}
      >
        {tooltipInfo}
      </Modal>
    </>
  ) : (
    <MenuMainConsumer>
      {({ menuNode }) => (
        <TooltipButton
          isMobile={false}
          position={tablet ? 'bottom' : 'left'}
          topIndentNode={menuNode}
          leftIndentNode={tablet ? textRef : leftIndentNode}
          close={{
            click: !tablet,
            scroll: false,
            resize: true,
            cross: tablet,
          }}
          deltaArrow={{
            x: 0,
            y: 0,
          }}
          indents={{
            left: 0,
          }}
          content={tooltipInfo}
        >
          <LinkInlineArrowShort as="span" className="link--inverted text-left">
            <TextSmallDescr
              ref={textRef}
              dangerouslySetInnerHTML={{
                __html: texts.delivery.content,
              }}
            />
          </LinkInlineArrowShort>
        </TooltipButton>
      )}
    </MenuMainConsumer>
  )
}

DeliveryTooltip.propTypes = {
  /** Object with texts for subscription */
  texts: PropTypes.object.isRequired,
  path: PropTypes.string.isRequired,
  tablet: PropTypes.bool.isRequired,
  mobile: PropTypes.bool.isRequired,
  leftIndentNode: PropTypes.object,
}

export default React.memo(DeliveryTooltip)
